<script>
import { ref } from "vue";

export default {
  props: {
    list: Array,
    height: Number,
  },

  setup(props) {
    const allAnswers = props.list.reduce((accumulator, currentValue) => {
      return [...accumulator, ...currentValue.jawaban];
    }, []);

    const items = ref(allAnswers.map((item) => ({ ...item, list: 1 })));

    const getList = (list) => {
      return items.value.filter((item) => item.list == list);
    };

    const startDrag = (event, item) => {
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("itemID", item.idjawaban);
    };

    const onDrop = (event, list) => {
      const itemID = event.dataTransfer.getData("itemID");
      const item = items.value.find((item) => item.idjawaban == itemID);
      if (list !== 1 && getList(list).length > 0) {
        return;
      }
      item.list = list;
    };

    const onDragLeave = () => {};

    return {
      getList,
      onDrop,
      startDrag,
      onDragLeave,
    };
  },

  data() {
    return {
      link: process.env.VUE_APP_BACKEND_URL,
    };
  },

  methods: {
    clickSelectedJawaban(item) {
      item.list = 1;
    },
  },
};
</script>

<template>
  <div class="mym-question-body">
    <div class="mym-question-cardbox">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          <strong>Petunjuk Menjodohkan</strong>
        </div>
      </div>

      <div class="mym-question-section">
        <p>Silahkan pilih salah satu jawaban dengan klik pada pilihan jawaban yang tersedia.</p>
        <p>Klik "preview" untuk menampilkan gambar</p>

        <div class="mb-3">
          <b>Contoh Soal</b>

          <!-- Studi Kasus -->
          <div class="mym-card-case mt-2 mb-3" v-if="list[0]?.soal_text">
            <div class="mym-card-jumbotron-header">
              <div class="mym-card-jumbotron-icon text-light">
                <i class="fa fa-file-alt"></i>
              </div>
              <h3 class="mym-card-jumbotron-title">Studi Kasus</h3>
            </div>
            <div class="mym-card-jumbotron-content">
              {{ list[0]?.soal_text }}
            </div>
          </div>

          <!-- Gambar soal -->
          <img
            v-if="list[0]?.soal_image"
            :src="link + list[0].soal_image"
            style="max-width: 70vw"
            class="mx-auto mb-2 d-block"
          />

          <table
            class="table align-middle table-nowrap table-striped table-bordered font-size-14"
          >
            <thead class="table-primary">
              <tr>
                <td width="5%" style="text-align: center">No</td>
                <td width="50%">Soal</td>
                <td width="35%">Jawab</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="soal in list" :key="soal.idsoal">
                <td width="5%" style="text-align: center">
                  {{ soal.nomor_urut }}
                </td>
                <td width="50%">{{ soal.pertanyaan }}</td>
                <td width="35%">
                  <div
                    class="drop-zone"
                    style="border-radius: 5px"
                    @drop="onDrop($event, 2)"
                    @dragenter.prevent
                    @dragover.prevent
                    @dragleave="onDragLeave"
                  >
                    <div
                      v-for="item in getList(2)"
                      :key="item.idjawaban"
                      style="border-radius: 5px"
                      class="drag-el"
                      draggable="true"
                      @dragstart="startDrag($event, item)"
                      @click="clickSelectedJawaban(item)"
                    >
                      {{ item.jawaban }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- OPTIONS SECTION -->
  <div
    class="mym-question-body answerlist-box"
    :style="{ top: 0, height: '100%' }"
    style="max-width: 30%"
  >
    <div class="mym-question-cardbox" style="height: 100%">
      <h4 class="mym-title-header">Pilihan Jawaban</h4>

      <div
        class="drop-zone pilihan-zone h-100"
        style="border-radius: 5px; max-height: 100%; overflow: auto"
        @drop="onDrop($event, 1)"
        @dragenter.prevent
        @dragover.prevent
      >
        <div
          v-for="item in getList(1)"
          :key="item.idjawaban"
          style="border-radius: 5px"
          class="drag-el m-2"
          draggable="true"
          @dragstart="startDrag($event, item)"
        >
          {{ item.jawaban }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.drop-zone {
  background-color: #ecf0f1;
  padding: 5px;
  min-height: 30px;
  text-align: center;
}
.drag-el {
  background-color: #556ee6;
  color: white;
  padding: 5px;
}
</style>
